'use client';
import { Box } from '@mui/material';
import React from 'react';

function CKEditorResult({ content, title, type }) {
  const updatedData = content?.replace(
    /<img(?![^>]*alt=)([^>]*)>/g,
    `<img alt=${title} $1>`,
  );
  const updatedData2 = updatedData?.replace(
    /<img(?![^>]*loading=)([^>]*)>/g,
    `<img loading="lazy" $1>`,
  );

  return (
    <Box
      dangerouslySetInnerHTML={{
        __html: updatedData2,
      }}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        lineHeight: '2.4em',
        width:
          type === 'مقاله'
            ? { xs: '92%', sm: '80%', lg: '70%', xl: '90%' }
            : '100%',
        margin: 'auto',
        textAlign: 'justify',
        '& .marker-yellow': {
          backgroundColor: '#ffe81c',
        },
        '& p, ol , li': {
          fontSize: { xs: '16px', md: '17px' },
          fontWeight: 400,
          m: 0,
        },
        '& blockquote': {
          borderRight: 'solid 5px hsl(0, 0%, 80%)',
          overflow: 'hidden',
          paddingRight: '1.5em',
          paddingLeft: '1.5em',
          marginLeft: 0,
          marginRight: 0,
          fontStyle: 'italic',
        },
        '& table': {
          overflow: 'hidden',
          orderCollapse: 'collapse',
          borderSpacing: 0,
          width: '100%',
          height: '100%',
          border: '1px double hsl(0, 0%, 70%)',
          '& th': {
            minWidth: '2em',
            padding: '.4em',
            border: '1px solid hsl(0, 0%, 75%)',
            fontWeight: 'bold',
            background: 'hsla(0, 0%, 0%, 5%)',
            textAlign: 'right',
          },
          '& td': {
            minWidth: '2em',
            padding: '.4em',
            border: '1px solid hsl(0, 0%, 75%)',
            overflowWrap: 'break-word',
            position: 'relative',
          },
          '& thead': {
            borderCollapse: 'collapse',
            borderSpacing: 0,
          },
        },
        ' & h2': {
          my: 1,
          fontSize: { xs: '1.3rem', md: '1.5rem' },
        },
        '& hr': {
          width: '100%',
          height: '1px',
          bgcolor: 'rgba(0,0,0,0.7)',
          border: '0px',
          margin: '15px 0',
        },
        '& figure': {
          margin: 'auto',
          my: 5,
          '& figcaption': {
            textAlign: 'center',
            pt: '3px',
          },
          '& img': {
            width: '100% !important',
            height: '100% !important',
            margin: 'auto',
          },
        },
      }}></Box>
  );
}

export default CKEditorResult;
